// extracted by mini-css-extract-plugin
export var root = "Carousel-module--root--3weYc";
export var arrow = "Carousel-module--arrow--3lnVS";
export var arrowPrev = "Carousel-module--arrowPrev--5laUJ";
export var animated = "Carousel-module--animated--1vOBe";
export var gradient = "Carousel-module--gradient--9FtMX";